var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24551 4.21518C7.23953 1.26161 12.0938 1.26161 15.0878 4.21518L16.5 5.60829L17.9122 4.21518C20.9062 1.26161 25.7605 1.26161 28.7545 4.21518C31.7485 7.16876 31.7485 11.9575 28.7545 14.911L16.5 27L4.24551 14.911C1.2515 11.9575 1.2515 7.16876 4.24551 4.21518Z",
    stroke: "#273454",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListFavourite);
export default __webpack_public_path__ + "static/media/icon-list-favourite.d6ac3d98c50c3912f789e357a33ea3c7.svg";
export { ForwardRef as ReactComponent };